// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ResidencyView_Wrapper__26Iv4","PageImage":"ResidencyView_PageImage__1Mvju"};